import { useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import CustomModal from '@/resources/components/global/CustomModal';
import MoneyDisplay from '@/resources/components/global/MoneyDisplay/MoneyDisplay';
import { useDevice } from '@/resources/hooks/useDevice';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

import { AddCombosModalController } from '../AddCombosModalController';
import { getQuantitiesOnEdit } from '../utils';

export function ComboAddModal({
  show,
  onClose,
  product,
}: {
  show: boolean;
  onClose: () => void;
  product: IProduct | undefined;
}) {
  const { order } = useWebContext();
  const { device } = useDevice();

  const [quantities, setQuantities] = useState<Record<number, number>>({});

  const controller = useMemo(
    () => new AddCombosModalController(order, product, quantities, onClose),
    [order, product, quantities, onClose],
  );

  const { combo_price, products_total } = controller.comboInfo;

  useEffect(() => {
    const products = controller.getProducts();
    if (products)
      getQuantitiesOnEdit(
        products?.filter((p: ICartProduct) =>
          controller.isProgressive ? p.quantity === controller.mainProduct?.quantity : true,
        ) as ICartProduct[],
        setQuantities,
      );
  }, [controller.mainProduct]);

  return (
    <CustomModal show={show} onHide={onClose} size="md" centered>
      <Modal.Body className="p-1 pt-3">
        <p className="text-center d-flex flex-column" style={{ fontSize: '1.25rem' }}>
          Deseja adicionar mais um
          <strong>Combo {controller.comboName}</strong>
          <span>
            Economize mais <MoneyDisplay value={products_total - combo_price} /> adicionando mais um
            combo!
          </span>
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center flex-md-row flex-column-reverse w-100">
        <Button
          variant="outline-secondary"
          onClick={() => {
            if (product) {
              controller.addComboProduct(product);
            }
            onClose();
          }}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Não, apenas o produto
        </Button>
        <Button
          variant="primary"
          onClick={() => controller.handleSubmitComboPromotion()}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Sim
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
